
export const geo = (parameters, fundata) => {
    $.getJSON(`https://restapi.amap.com/v3/geocode/geo?${parameters}&key=75cd6437ae5e2d9cbf7b3d9ff796d5cf`, fundata)
}

export const regeo = (parameters, fundata) => {
    $.getJSON(`https://restapi.amap.com/v3/geocode/regeo?${parameters}&key=75cd6437ae5e2d9cbf7b3d9ff796d5cf`, fundata)
}

